import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { WorkflowTaskCounterModule } from '@lib/workflow-integration';
import { DebugModule, NavigationModule, PlatformModule } from '@lib/core';
import { BadgeModule, ClickOutsideModule, DefineVariableModule, FileToBase64Module } from '@lib/util';
import { TranslateModule } from '@ngx-translate/core';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { DropdownUserComponent } from './dropdown-user/dropdown-user.component';
import { LogoComponent } from './logo/logo.component';
import { PageHeaderComponent } from './page-header/page-header.component';
import { SearchComponent } from './page-header/search/search.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { ShopNameComponent } from './page-header/shop-name/shop-name.component';
import { BarcodeScanner } from '@awesome-cordova-plugins/barcode-scanner/ngx';
import { MatButtonModule } from '@angular/material/button';
import { IimSpinnerModule } from '@iim-angular/components';
import { MatBadgeModule } from '@angular/material/badge';
import { SharedBasketHeaderUiModule } from '@lib/basket-header';
import { AvatarModule } from 'primeng/avatar';
import { FeatureActiveDirective } from '@lib/feature-toggle';

@NgModule({
    declarations: [
        SidebarComponent,
        LogoComponent,
        PageHeaderComponent,
        DropdownUserComponent,
        SearchComponent,
        ShopNameComponent,
    ],
    imports: [
        CommonModule,
        BsDropdownModule.forRoot(),
        TranslateModule,
        NavigationModule,
        FormsModule,
        ReactiveFormsModule,
        ClickOutsideModule,
        BadgeModule,
        WorkflowTaskCounterModule,
        RouterModule,
        DefineVariableModule,
        FileToBase64Module,
        PlatformModule,
        MatButtonModule,
        IimSpinnerModule,
        DebugModule,
        MatBadgeModule,
        SharedBasketHeaderUiModule,
        AvatarModule,
        FeatureActiveDirective,
    ],
    providers: [BarcodeScanner],
    exports: [SidebarComponent, PageHeaderComponent, DropdownUserComponent],
})
export class LayoutModule {}
